import { useMap as x } from "@vis.gl/react-google-maps";
import { useState as a, useEffect as M } from "react";
function z({ padding: o = 0 } = {}) {
  const t = x("station-map"), [u, i] = a([-180, -90, 180, 90]), [m, g] = a(0);
  return M(() => {
    if (!t) return;
    const p = t.addListener("bounds_changed", () => {
      const n = t.getBounds(), s = t.getZoom(), f = t.getProjection();
      if (!n || !s || !f) return;
      const r = n.getSouthWest(), c = n.getNorthEast(), e = w(s) * o, d = Math.min(90, c.lat() + e), h = Math.max(-90, r.lat() - e), l = r.lng() - e, b = c.lng() + e;
      i([l, h, b, d]), g(s);
    });
    return () => p.remove();
  }, [t, o]), { bbox: u, zoom: m };
}
function w(o) {
  return 360 / (Math.pow(2, o) * 256);
}
export {
  z as useMapViewport
};
